/*
* @Description: 排号管理 配置、重置排号模板
* @Author: ma.cq
* @Date: 2018-10-23 19:22:00
* @LastEditors: ma.cq
* @LastEditTime: 2018-10-23 20:20:54
*/
<template>
  <el-dialog :title="title" :visible.sync="visible" @close="handleClose" width="800px">
    <el-form class="form" :model="form" ref="form" :rules="rules" label-width="120px">
      <el-form-item label="放号时段" prop="releaseNumType">
        <el-radio-group v-model="form.releaseNumType" @change="typeChange">
          <el-radio label="1">全天放号</el-radio>
          <el-radio label="3">自定义时段</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="放号数量" required>
        <template v-if="form.releaseNumType === '1'">
          <el-form-item prop="maxNum">
            <el-input-number
              v-model="form.maxNum"
              controls-position="right"
              :min="0"
              :precision="0">
            </el-input-number>
          </el-form-item>
        </template>
        <template v-else-if="form.releaseNumType === '3'">
          <el-row v-for="(item, index) of form.times" :key="index">
            <el-col class="times" :span="12">
              <el-form-item :prop="`times[${index}].startTime`" :rules="rules.startTime">
                <el-time-select
                  placeholder="开始时间"
                  v-model="item.startTime"
                  class="time-select-width"
                  :picker-options="{
                    start: '00:00',
                    step: '00:01',
                    end: '23:59'
                  }"></el-time-select>
              </el-form-item>
              至
              <el-form-item :prop="`times[${index}].endTime`" :rules="rules.endTime">
                <el-time-select
                  placeholder="结束时间"
                  v-model="item.endTime"
                  class="time-select-width"
                  :picker-options="{
                    start: '00:00',
                    step: '00:01',
                    end: '23:59'
                  }"></el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :prop="`times[${index}].num`" :rules="rules.num">
                <el-input-number
                  v-model="item.num"
                  controls-position="right"
                  :min="0"
                  :precision="0"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="index === 0">
              <el-button @click="addTime">+</el-button>
            </el-col>
            <el-col :span="2" v-if="index !== 0">
              <el-button @click="delTime(index)">-</el-button>
            </el-col>
            <el-col v-if="item.orderNum !== ''" :span="3">
              已预约：{{item.orderNum}}人
            </el-col>
          </el-row>
        </template>
        <el-row>
          模板设置后，系统将为您自动生成七天内的数据，之后顺延一天将自动设置七天后的数据！
        </el-row>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'setOrResetDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    },
    id: {
      type: String,
      default: ''
    },
    isUpdate: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: this.show,
      appointId: '',
      modelId: '',
      allTimeId: '',
      form: {
        releaseNumType: '1',
        maxNum: '',
        times: [{
          startTime: '',
          endTime: '',
          num: '',
          id: '',
          orderNum: ''
        }],
        delTimeIds: []
      },
      rules: {
        releaseNumType: [{ required: true, message: '请选择放号时段类型' }],
        maxNum: [{ required: true, message: '请输入放号数量' }],
        startTime: [{ required: true, message: '请选择开始时间' }],
        endTime: [{ required: true, message: '请选择结束时间' }],
        num: [{ required: true, message: '请输入放号数量' }]
      }
    }
  },
  computed: {
    title () {
      return this.$lodash.isEmpty(this.formData) ? '配置模板' : '重新排号'
    },
    ...mapGetters({
      current: 'getPickCurrentAppoint'
    })
  },
  methods: {
    ...mapActions(['appointConfigTemplate', 'appointTemplateDetail', 'appointUpdateTemplateDetail', 'appointUpdateTemplate', 'appointNumMouldList']),
    typeChange () {
    },
    addTime () {
      this.form.times.push({
        startTime: '',
        endTime: '',
        num: ''
      })
    },
    delTime (index) {
      const delId = this.form.times[index].id
      if (delId) {
        this.form.delTimeIds.push(delId)
      }
      this.form.times.splice(index, 1)
    },
    valiTimes () {
      const arr = this.form.times
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]
        if (item.startTime >= item.endTime) {
          this.$message.warning('结束时间要晚于开始时间')
          return false
        }
        if (i > 0) {
          const lastItem = arr[i - 1]
          if (item.startTime <= lastItem.endTime) {
            this.$message.warning('开始时间要晚于上一阶段结束时间')
            return false
          }
        }
      }
      return true
    },
    handleSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.releaseNumType === '3' && !this.valiTimes()) {
            return
          }
          //
          let arr = []
          if (this.form.releaseNumType === '1') {
            arr = [{
              onlineMaxCount: this.form.maxNum,
              type: 0,
              id: this.allTimeId
            }]
          } else if (this.form.releaseNumType === '3') {
            arr = this.form.times.map(item => {
              return {
                customTime: [item.startTime, item.endTime],
                onlineMaxCount: item.num,
                type: 13,
                id: item.id
              }
            })
          }
          let obj = {
            releaseNumType: this.form.releaseNumType,
            releaseNumRule: 1,
            templateId: this.modelId,
            bookingNumberFragmentDetails: arr,
            // 重新配置模板不传
            delRangeNumDetailId: this.info.isNum === 1 ? this.form.delTimeIds : null
          }
          if (this.isUpdate) {
            if (this.info.isNum === 0) {
              obj.id = this.appointId
              this.appointConfigTemplate(obj).then(() => { // manage/delivery/template/config
                this.appointNumMouldList(this.info).then(res => {
                  this.$emit('childByValue', res)
                })
                this.visible = false
              })
            } else {
              obj.id = this.appointId
              this.appointUpdateTemplate(obj).then(() => { // manage/delivery/booking/number/update
                this.appointNumMouldList(this.info).then(res => {
                  this.$emit('childByValue', res)
                })
                this.visible = false
              })
            }
          } else {
            obj.poolID = this.current.id
            this.appointConfigTemplate(obj).then(() => { // manage/delivery/template/config
              this.appointNumMouldList(this.info).then(res => {
                this.$emit('childByValue', res)
              })
              this.visible = false
            })
          }
        } else {
          return false
        }
      })
    },
    handleClose () {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      const initForm = {
        releaseNumType: '1',
        maxNum: '',
        times: [{
          startTime: '',
          endTime: '',
          num: '',
          id: '',
          orderNum: ''
        }],
        delTimeIds: []
      }
      // 显示dialog时给form赋初始值
      if (newVal) {
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
          this.$refs['form'].resetFields()
        })
        if (this.id) { // 重新排号 或者 重新配置模板
          const fn = (res) => {
            if (res.releaseNumType === 1) { // 全时段
              initForm.releaseNumType = '1'
              initForm.maxNum = res.bookingNumberFragmentDetails[0].onlineMaxCount
              this.allTimeId = res.bookingNumberFragmentDetails[0].id
            } else if (res.releaseNumType === 3) {
              initForm.releaseNumType = '3'
              initForm.times = res.bookingNumberFragmentDetails.map(item => {
                return {
                  startTime: item.customTime[0],
                  endTime: item.customTime[1],
                  num: item.onlineMaxCount,
                  id: item.id,
                  orderNum: item.orderNum
                }
              })
            }
            this.form = { ...initForm }
            this.appointId = res.id
            this.modelId = res.templateId
          }
          if (this.info.isNum === 1) { // 重新排号时获取详情
            this.appointUpdateTemplateDetail({ id: this.id }).then(res => {
              fn(res)
            })
          } else {
            this.appointTemplateDetail({ id: this.id }).then(res => {
              fn(res)
            })
          }
        } else { // 配置模板
          this.form = { ...initForm }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .times {
    display: flex;
    justify-content: space-between;
    margin-right: 10px;
  }

  .form-input-inline {
    width: 140px;
  }

  .marTop10 {
    margin-top: 10px;
  }

  .four-part-box {
    .el-row:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  .text-center{
    text-align: center;
  }
  .time-select-width{
    width: 135px;
  }
</style>
